import React, { useState } from 'react';
import { Grid, Box, useMediaQuery, Modal } from '@mui/material';

// Icons
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import MapIcon from '@mui/icons-material/Map';
import { PlayCircle, QrCode } from '@mui/icons-material';

// Styles
import {
  CustomCard,
  Title,
  Subtitle,
  Description,
  ContainerGroupButtons,
  ContainerContent,
  BoxModal,
  HeaderContainer,
  TitleSection,
  WorkflowStatusSection,
  IconContainer,
  ContainerButtons,
} from './styles';

// Utils
import { getIcon } from '../../../utils/iconConfig';
import { useTranslation } from 'react-i18next'
import { PlotPlanView } from '../../PlotPlanView';


// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../Context/PermissionsContext';
import { QrModalCard } from '../modalCards/QrModalCard';
import { WorkflowDataApi } from '../../../services/WorkflowDataApi';
import { toast } from 'react-toastify';
import { getQrType } from '../../../utils/commonFunctions';
import { useOffline } from '../../../Context/OfflineContext';
import { CustomButtonV2 } from '../../../pages/styles';
import moment from 'moment';

export default function WorkPermitDetailData({ data, workflow, handleOpenStatus, isExternal, idDisable, setOpendownloadValidations, canDownloadRevalidations, isLotoWorkflow, hasEditedData, handleOpenQrScan }) {
  const { t } = useTranslation();
  const ability = useAbility(AbilityContext);
  const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const isMediumOrSmaller = useMediaQuery(theme => theme.breakpoints.down('md'));
  const isMedium = isMediumOrSmaller && !isSmall; // sm to md
  const workflowDataApi = new WorkflowDataApi();
  const { connectionStatus } = useOffline();

  // Plot Plan modal
  const [plotPlanModal, setPlotPlanModal] = React.useState(false);
  const [plotPlanData, setPlotPlanData] = React.useState({});

  const [qrOpen, setQrOpen] = useState(false);
  const [qrUrl, setQrUrl] = useState(null);
  const [dataQR, setDataQR] = useState({ title: '', type: '', code: '' })
  const [loadingData, setLoadingData] = useState(false);
  const [updatedAt, setUpdatedAt] = useState('');
  const [validityDate, setValidityDate] = useState({ from: '', to: '' });
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);

  const handleScroll = (e) => {
    const { scrollLeft, scrollWidth, clientWidth } = e.target;
    if (scrollLeft + clientWidth >= scrollWidth - 2) {
      setShowScrollIndicator(false);
    } else {
      setShowScrollIndicator(true);
    }
  };

  function openPlotPlan() {
    setPlotPlanData(data)
    setPlotPlanModal(true)
  }

  const handleCloseQr = () => {
    if (qrUrl) URL.revokeObjectURL(qrUrl);
    setQrUrl(null);
    setQrOpen(false);
  };

  const handleViewQr = async (data) => {
    try {
      setLoadingData(true);
      let workflowId = data.id;
      setDataQR({
        title: data.plant?.name ?? ". . .",
        type: getQrType(data.type),
        code: data.code
      })

      const response = await workflowDataApi.downloadQR([workflowId]);

      if (!response || response.status !== 200) {
        toast.error(t('asset.qrFailed'));
        return;
      }

      const blob = new Blob([response.data], { type: 'image/png' });
      const url = URL.createObjectURL(blob);

      setQrUrl(url);
      setQrOpen(true);

    } catch (err) {
      console.error(err);
      toast.error(t('asset.qrFailed'));
    } finally {
      setLoadingData(false);
    }
  };

  React.useEffect(() => {
  }, [workflow])

  React.useEffect(() => {
    if (data?.updatedAt) {
      const updatedAt = moment(data.updatedAt).format("DD/MM/YYYY h:mm A");
      setUpdatedAt(updatedAt);
    }

    const validityDate = {from: '', to: ''};
    if (moment(data?.characteristics?.validityFrom ?? '').isValid()) {
      validityDate.from = moment(data.characteristics?.validityFrom).format("DD/MM/YYYY");
    }
    if (moment(data?.characteristics?.validityTo ?? '').isValid()) {
      validityDate.to = moment(data.characteristics?.validityTo).format("DD/MM/YYYY");
    }
    setValidityDate(validityDate)
  }, [data])

  return (
    <React.Fragment>
      <ContainerContent>
        <Grid item xs={12} sx={{ height: '100%' }}>
          {/* Pantalla portatil y desktop  */}
          <CustomCard>

            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <HeaderContainer>
                <TitleSection>
                  <Title variant="h5">{data?.code ? data?.code : data?.id}</Title>

                  <WorkflowStatusSection>
                    <IconContainer>
                      {getIcon(data?.workflowStatus)}
                    </IconContainer>

                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <Description sx={{ fontSize: '12px', lineHeight: 1.2 }}>
                        {data?.workflowStatus?.subtitle}
                      </Description>
                      <Description sx={{ fontSize: '12px', fontWeight: 600, lineHeight: 1.2 }}>
                        {data?.workflowStatus?.title}
                      </Description>
                      <Description sx={{ fontSize: '12px', lineHeight: 1.2 }}>
                        {data?.workflowStatus?.date}
                      </Description>
                    </div>
                  </WorkflowStatusSection>
                </TitleSection>

                {(!isSmall || (isSmall && isLotoWorkflow)) &&
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    gap: 6,
                    width: (isMedium || (isSmall && isLotoWorkflow)) ? "100%" : "65%",
                    marginTop: (isMedium || (isSmall && isLotoWorkflow)) ? "16px" : 0,
                  }}>
                    {(!isExternal) && (
                      <>
                        <ContainerGroupButtons>
                          <ContainerButtons>
                            {connectionStatus &&
                              <CustomButtonV2
                                onClick={() => handleViewQr(data)}
                                variant="contained"
                                btnType="secondary"
                                startIcon={<QrCode />}
                                inverted
                              >
                                {t('asset.table.tooltip.viewQR')}
                              </CustomButtonV2>
                            }
                          </ContainerButtons>

                          {(ability.can("PlotPlanList") && ability.can("GetPlotPlan")) &&
                            <ContainerButtons>
                              {connectionStatus &&
                                <CustomButtonV2
                                  onClick={() => openPlotPlan()}
                                  variant="contained"
                                  btnType="primary"
                                  startIcon={<MapIcon />}
                                >
                                  {t('workflow.detail.plotPlan')}
                                </CustomButtonV2>
                              }
                            </ContainerButtons>
                          }

                          {canDownloadRevalidations.current &&
                            <ContainerButtons>
                              <CustomButtonV2
                                onClick={() => setOpendownloadValidations(true)}
                                variant="contained"
                                startIcon={<DownloadForOfflineIcon />}
                              >
                                {t('common.actions.revalidations')}
                              </CustomButtonV2>
                            </ContainerButtons>
                          }

                          <ContainerButtons>
                            <CustomButtonV2
                              onClick={() => {
                                if (isLotoWorkflow && handleOpenQrScan) {
                                  handleOpenQrScan(data, workflow)
                                } else {
                                  handleOpenStatus(data)
                                }
                              }}
                              variant="contained"
                              startIcon={<PlayCircle />}
                              disabled={idDisable === 10003 || idDisable === 10002 || hasEditedData}
                              processButton
                            >
                              {t('common.actions.process')}
                            </CustomButtonV2>
                          </ContainerButtons>
                        </ContainerGroupButtons>
                      </>
                    )}
                  </div>
                }
              </HeaderContainer>

              <Grid container spacing={1} pt={1}>
                {data?.title &&
                  <Grid item xs={12}>
                    <Subtitle variant="body2" component="div">{t('workflow.detail.title')}</Subtitle>
                    <Description variant="body2" component="div">{data?.title}</Description>
                  </Grid>
                }

                {data?.plant?.name &&
                  <Grid item xs={6} md={4} lg={3}>
                    <Subtitle variant="body2" component="div">{t('workflow.table.plant')}</Subtitle>
                    <Description variant="body2" component="div">{data.plant?.name}</Description>
                  </Grid>
                }

                <Grid item xs={6} md={4} lg={3}>
                  <Subtitle variant="body2" component="div">{t('workflow.detail.contract')}</Subtitle>
                  <Description variant="body2" component="div">{data?.contract?.code}</Description>
                </Grid>

                <Grid item xs={6} md={4} lg={3}>
                  <Subtitle variant="body2" component="div">{t('workflow.detail.lastUpdate')}</Subtitle>
                  <Description variant="body2" component="div">{updatedAt}</Description>
                </Grid>

                <Grid item xs={6} md={4} lg={3}>
                  <Subtitle variant="body2" component="div">{t('workflow.detail.validityInstance')}</Subtitle>
                  <Description variant="body2" component="div">
                    {`${validityDate.from} - ${validityDate.to}`}
                  </Description>
                </Grid>

                {(data?.workflowStatus?.statusId === 10003 && data?.cancelObservations) &&
                  <Grid item xs={12}>
                    <Subtitle variant="body2" component="div">{t('forms.characteristics.deletionJustification')}</Subtitle>
                    <Description variant="body2" component="div">{data?.cancelObservations}</Description>
                  </Grid>
                }
              </Grid>

            </Box>

          </CustomCard>

          {(isSmall && !isLotoWorkflow) && (
            <Box sx={{ mt: 2, position: 'relative', width: '100%' }}>
              <Box
                onScroll={handleScroll}
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 1,
                  overflowX: 'auto',
                  overflowY: 'hidden',
                  pb: 1, // Espacio para la barra de desplazamiento
                  '&::-webkit-scrollbar': {
                    height: '6px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(0,0,0,.2)',
                    borderRadius: '3px',
                  }
                }}
              >
                  {(!isExternal) && (
                      <>
                          <ContainerButtons>
                            <CustomButtonV2
                              onClick={() => {
                                if (isLotoWorkflow && handleOpenQrScan) {
                                  handleOpenQrScan(data, workflow)
                                } else {
                                  handleOpenStatus(data)
                                }
                              }}
                              variant="contained"
                              startIcon={<PlayCircle />}
                              disabled={idDisable === 10003 || idDisable === 10002 || hasEditedData}
                              processButton
                              sx={{ whiteSpace: 'nowrap' }}
                            >
                              {t('common.actions.process')}
                            </CustomButtonV2>
                          </ContainerButtons>

                            {connectionStatus &&
                              <ContainerButtons>
                                <CustomButtonV2
                                  onClick={() => handleViewQr(data)}
                                  variant="contained"
                                  btnType="secondary"
                                  startIcon={<QrCode />}
                                  inverted
                                  sx={{ whiteSpace: 'nowrap' }}
                                >
                                  {t('asset.table.tooltip.viewQR')}
                                </CustomButtonV2>
                              </ContainerButtons>
                            }

                          {(ability.can("PlotPlanList") && ability.can("GetPlotPlan")) &&
                            <ContainerButtons>
                              {connectionStatus &&
                                <CustomButtonV2
                                  onClick={() => openPlotPlan()}
                                  variant="contained"
                                  btnType="primary"
                                  startIcon={<MapIcon />}
                                  sx={{ whiteSpace: 'nowrap' }}
                                >
                                  {t('workflow.detail.plotPlan')}
                                </CustomButtonV2>
                              }
                            </ContainerButtons>
                          }

                          {canDownloadRevalidations.current &&
                            <ContainerButtons>
                              <CustomButtonV2
                                onClick={() => setOpendownloadValidations(true)}
                                variant="contained"
								                btnType="primary"
                                startIcon={<DownloadForOfflineIcon />}
                                sx={{ whiteSpace: 'nowrap' }}
                              >
                                {t('common.actions.revalidations')}
                              </CustomButtonV2>
                            </ContainerButtons>
                          }
                      </>
                    )}
              </Box>

              {/* Indicador visual de desborde a la derecha */}
              {showScrollIndicator && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    bottom: '8px',
                    right: 0,
                    width: '40px',
                    background: 'linear-gradient(to right, transparent, #fbfcfd 90%)',
                    pointerEvents: 'none',
                    zIndex: 2,
                    transition: 'opacity 0.2s',
                  }}
                />
              )}
            </Box>
          )} 
        </Grid>

        {connectionStatus &&
          <Modal open={qrOpen}>
            <BoxModal>
              <QrModalCard
                data={dataQR}
                loading={loadingData}
                qrUrl={qrUrl}
                handleCloseQr={handleCloseQr}
              />
            </BoxModal>
          </Modal>
        }
      </ContainerContent>

      {connectionStatus &&
        <PlotPlanView
          data={plotPlanData}
          openDialog={plotPlanModal}
          handleCloseDialog={() => setPlotPlanModal(false)}
        />
      }
    </React.Fragment>
  );
}
